export default {
  RutaApi: 'https://api.gcolumbia.com//api',
  RutaRAR: '/Uploads/rar/',
  RutaRecibos: '/Uploads/nominas/',
};
